(function () {
    'use strict';


    angular.module('swif.ui')
    .directive('swifInputState', swifInputState)
    .directive('swifInputText', swifInputText)
    .directive('swifInputCurrency', swifInputCurrency)
    .directive('swifInputNumber', swifInputNumber)
    .directive('swifInputDate', swifInputDate)
    .directive('swifInputDatetime', swifInputDatetime)
    .directive('swifInputSwitch', swifInputSwitch)
    .directive('swifInputTextarea', swifInputTextarea)
    .directive('swifInputFile', swifInputFile)
    .directive('swifInputSelectMultiple', swifInputSelectMultiple)
    .directive('swifInputSelectOne', swifInputSelectOne)
    .directive('swifInputSelectContainsMultiple', swifInputSelectContainsMultiple)
    .directive('swifInputSelectMultipleFreeChar', swifInputSelectMultipleFreeChar);


    /**
     * @ngdoc directive
     * @name swif.ui:swifInputState
     * @module swif.ui
     * @restrict E
     * @description
     **/
    function swifInputState(swif) {
        'ngInject';
        var ret = {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                callback: '&?',
                mode: '@?',  // 'button', 'button-icon', 'dropdown', dropdown-icon,...
                contentType: '@type',
                ngDisabled: '=?',
                readonly: '=?',
                choices: '@?'
            },
            link: function (scope, element, attr, ngModel) {
                scope.sync = function () {
                    ngModel.$setViewValue(scope.proxy.value);
                };
                scope.initialize = function () {
                    if (!scope.choices) {
                        scope.choices = 'states';
                    }
                    scope.proxy = {value: null};
                    if (!scope.mode) {
                        scope.mode = 'button';
                    }
                    scope.proxy.states = swif.settings.app.contentTypes[scope.contentType][scope.choices];
                    // @TODO: use statesArray ONLY (was initially added to fix orderBy of ngRepeat)
                    // the proxy.states should be replaced by statesArray (comparing reference instead ?)
                    scope.proxy.statesArray = [];
                    // @NOTES: from {'draft': {...}} to [{'key': 'draft', ...}]
                    _.forOwn(scope.proxy.states, function (state, key) {
                        var newItem = angular.copy(state);
                        newItem.key = key;
                        scope.proxy.statesArray.push(newItem);
                    });
                    ngModel.$render = function () {
                        var vv = ngModel.$viewValue;
                        scope.proxy.value = vv || scope.initValue;
                        scope.proxy.currentState = scope.proxy.states[scope.proxy.value];  // used for 'dropdown' mode
                    };
                };
                scope.initialize();
                scope.$watch('proxy.value', function (newV, oldV) {
                    if (!angular.equals(newV, oldV)) {
                        //catch the new value after click in dropdown mode
                        scope.proxy.currentState = scope.proxy.states[newV];
                        scope.sync();
                        // callback is undefined car rien de défini ds <swif-input-state, normal ?
                        if (scope.callback) {
                            scope.callback();
                        }
                    }
                });
            },
            templateUrl: 'partials/openresa/widget-state.html'
        };
        return ret;
    }

    /**
    * @ngdoc directive
    * @name swif.ui:swifInputText
    * @module swif.ui
    * @restrict E
    * @description
    **/
    function swifInputText(swifFormUtility) {
        'ngInject';
        var d = angular.copy(swifFormUtility.DEFAULT_WIDGET_DIRECTIVE);
        delete d.transclude;
        d.scope.ngMaxlength = '@?';
        d.scope.ngMinlength = '@?';
        d.scope.error = '=?';
        d.templateUrl = 'partials/ui/inputText.html';
        d.link = swifFormUtility.falseProxyLink;
        return d;
    }


    /**
    * @ngdoc directive
    * @name swif.ui:swifInputCurrency
    * @module swif.ui
    * @restrict E
    * @description
    **/
    function swifInputCurrency(swifFormUtility) {
        'ngInject';
        var d = angular.copy(swifFormUtility.DEFAULT_WIDGET_DIRECTIVE);
        d.scope.error = '=?';
        d.templateUrl = 'partials/ui/inputCurrency.html';
        d.link = swifFormUtility.falseProxyLink;
        return d;
    }


    /**
    * @ngdoc directive
    * @name swif.ui:swifInputNumber
    * @module swif.ui
    * @restrict E
    * @description
    **/
    function swifInputNumber(swifFormUtility) {
        'ngInject';
        var d = angular.copy(swifFormUtility.DEFAULT_WIDGET_DIRECTIVE);
        d.scope.error = '=?';
        d.templateUrl = 'partials/ui/inputNumber.html';
        d.link = swifFormUtility.falseProxyLink;
        return d;
    }


    /**
    * @ngdoc directive
    * @name swif.ui:swifInputDate
    * @module swif.ui
    * @restrict E
    * @description
    **/
    function swifInputDate(swifFormUtility) {
        'ngInject';
        var d = angular.copy(swifFormUtility.DEFAULT_WIDGET_DIRECTIVE);
        d.scope.error = '=?';
        d.scope.minDate = '=?';
        d.scope.noIcon = '=?';
        d.scope.customDateDisabled = '=?';
        d.templateUrl = 'partials/ui/inputDate.html';
        d.link = function (scope, element, attr, ngModel) {
            swifFormUtility.watchNgRequired(scope, element);
            swifFormUtility.copyAttributesToInput(scope, element, attr);
//            wrapNgModelWithProxy(scope, ngModel);
            swifFormUtility.addOpenBoolean(scope, element);
            scope.form = scope.$parent.form;
            swifFormUtility.addDateSupport(scope, element, attr, ngModel);
            swifFormUtility.addMinDateSupport(scope, element, attr, ngModel);
            swifFormUtility.addMaxDateSupport(scope, element, attr, ngModel);
        };
        return d;
    }

    /**
    * @ngdoc directive
    * @name swif.ui:swifInputDatetime
    * @module swif.ui
    * @restrict E
    * @description
    * @usage
    **/
    function swifInputDatetime(swifFormUtility) {
        'ngInject';
        var d = angular.copy(swifFormUtility.DEFAULT_WIDGET_DIRECTIVE);
        swifFormUtility.datetimeDirective(d);
        d.templateUrl = 'partials/ui/inputDatetime.html';
        d.scope.split = "=?";
        return d;
    }


    /**
    * @ngdoc directive
    * @name swif.ui:swifInputSelectOne
    * @module swif.ui
    * @restrict E
    * @description
    * @usage
    **/
    function swifInputSelectOne(gettextCatalog, swifFormUtility, dataService, settingsService) {
        'ngInject';
        var d = swifFormUtility.getSelectOneDefinition(gettextCatalog, dataService, settingsService);

        d.scope.allowClear = '=?';
        d.scope.formatName = '&?';
        d.scope.swifChange = '&?';
        d.scope.defaultSelected = '=?';
        d.scope.barcodeMode = '@?';
        d.scope.resetSearchInput = '@?';
        d.scope.limitResults = '@?';
        d.templateUrl = 'partials/ui/inputSelectOne.html';

        return d;
    }

    /**
    * @ngdoc directive
    * @name swif.ui:swifInputSelectMultiple
    * @module swif.ui
    * @restrict E
    * @description
    * @usage
    **/
    function swifInputSelectMultiple(gettextCatalog, swifFormUtility, dataService, settingsService) {
        'ngInject';
        var d = swifFormUtility.getSelectMultipleDefinition(gettextCatalog, dataService, settingsService);
        d.scope.eraser = '=?';
        d.scope.formatName = '&?';
        d.templateUrl = 'partials/ui/inputSelectMultiple.html';
        return d;
    }

    /**
    * @ngdoc directive
    * @name swif.ui:swifInputSelectContainsMultiple
    * @module swif.ui
    * @restrict E
    * @description
    * @usage
    **/
    function swifInputSelectContainsMultiple(gettextCatalog, swifFormUtility, dataService) {
        'ngInject';
        var d = swifFormUtility.getSelectMultipleDefinition(gettextCatalog, dataService);
        d.scope.eraser = '=?';
        d.templateUrl = 'partials/ui/swif_input_select_contains_multiple.html';
        return d;
    }

    /**
    * @ngdoc directive
    * @name swif.ui:swifInputSelectMultipleFreeChar
    * @module swif.ui
    * @restrict E
    * @description A multi select to add tags 'on the fly' without a prefilled dropdown
    * @usage
    *  <swif-input-select-multiple-free-char validation-type="{{validationType}}">
    *
    *  validation-type (optional) See widget
    **/
    function swifInputSelectMultipleFreeChar(gettextCatalog, swifFormUtility, dataService, swifModule) {
        'ngInject';
        var d = angular.copy(swifFormUtility.DEFAULT_WIDGET_DIRECTIVE);
        d.scope.validationType = '@?';
        d.scope.errorOnSelect = '@?';
        d.templateUrl = 'partials/ui/inputSelectMultipleFreeChar.html';
        d.link = function (scope, element, attr, ngModel) {
            let config = {
                'mobile': {
                    'msg': "Veuillez vérifier le numéro : doit être une série de 10 chiffres commençant par 06 ou 07",
                    'regex': swifModule.regex.mobile
                }
            };

            scope.errorMsg = config[scope.validationType].msg || '';
            scope.errorOnSelect = false;
            scope.proxy = { selected: [] };

            ngModel.$render = function () {
                scope.proxy.selected = ngModel.$viewValue;
            };

            // Update the model
            scope.$watch('proxy.selected', function (newV) {
                ngModel.$setViewValue(newV);
            });

            scope.onSelect = function(item, model) {
                let validationRegex = new RegExp(config[scope.validationType].regex);

                // Trim the selected value cause ui-select 'tagging-label' attribut adds a whitespace sometimes
                let trimmedItem = item.trim();
                // Immediately remove the selected item if it don't match the regex
                if( !validationRegex.test(trimmedItem) ) {
                    // Remove the last item from the array of selected items
                    scope.proxy.selected.pop();
                    scope.errorOnSelect = true;
                } else {
                    scope.errorOnSelect = false;
                }
            };
        }
        return d;
    }

    /**
    * @ngdoc directive
    * @name swif.ui:swifInputSwitch
    * @module swif.ui
    * @restrict E
    * @description
    **/
    function swifInputSwitch(swifFormUtility) {
        'ngInject';
        var d = swifFormUtility.checkboxDirective(d);
        d.templateUrl = 'partials/ui/inputSwitch.html';
        return d;
    }


    /**
    * @ngdoc directive
    * @name swif.ui:swifInputTextarea
    * @module swif.ui
    * @restrict E
    * @description
    **/
    function swifInputTextarea(swifFormUtility) {
        'ngInject';
        var d = angular.copy(swifFormUtility.DEFAULT_WIDGET_DIRECTIVE);
        d.scope.error = '=?';
        d.templateUrl = 'partials/ui/inputTextarea.html';
        d.link = swifFormUtility.falseProxyLink;
        return d;
    }

    /**
    * @ngdoc directive
    * @name swif.ui:swifInputFile
    * @module swif.ui
    * @restrict E
    * @description
    * instead of other swif-input-*, this directive will use the FileReader
    * API to return the new value of the ng-model
    **/
    function swifInputFile(swifFormUtility) {
        'ngInject';
        var d = angular.copy(swifFormUtility.DEFAULT_WIDGET_DIRECTIVE);
        delete d.transclude;
        d.scope.accept = '@';
        d.scope.autoReset = '=?';
        d.scope.encode = '=?';
        d.templateUrl = 'partials/ui/inputFile.html';
        d.link = function (scope, element, attr, ngModel) {
            swifFormUtility.falseProxyLink(scope, element, attr, ngModel);
            if (!scope.accept) {
                scope.accept = 'image/*';
            }
            if (scope.encode !== false) {  // if null or undefined
                scope.encode = true;
            }
            scope.filename = '';
            scope.sync = function (value) {
                scope.proxy = value;
            };
            // called by wrapNgModelWithOnchange to extend available variables
            scope.swifChangeContext = function () {
                return {filename: scope.filename};
            };

            // scope.proxy will store the NEW binary value, otherwise, the value is empty,
            // we only display the file as downloadable
            // (TODO: use 'filename' field to display the file-name)
            element.find('input[type=file]').bind('change', function (event) {
                var files = event.target.files;
                // on binary field, we handle only one file
                var fileToAdd = files[0];
                //if we are on chrome, parse the fakepath to retrieve the filename
                var filename = fileToAdd.name.split('/');
                filename = filename[filename.length - 1];
                scope.filename = filename;
                // now, implements the FileReader instance, to retrieve file b64 value
                var reader = new FileReader();
                var I = '<i class="fa fa-refresh fa-spin pull-right"></i>';
                element.parent().append(I);
                reader.onload = function(file){
                    if (scope.encode) {
                        scope.sync(btoa(file.target.result));
                    } else {
                        scope.sync(file.target.result);
                    }
                    element.parent().find('i.fa-spin').remove();
                    if (scope.autoReset) {
                        event.target.value = '';
                    }
                    scope.$apply();
                };
                if (scope.encode) {
                    // BinaryString read file byte per byte, handy when converting to b64
                    reader.readAsBinaryString(fileToAdd);
                } else {
                    // AsText read file using the charset, handy when writing file "as it" on the server
                    reader.readAsText(fileToAdd);
                }
            });
        };
        return d;
    }


})();
